const getters = {
  getNoteById: (state) => (id) => state.notes.find((n) => n.id === id) || null,
  getNotes: (state) => () => state.notes
 }

export default getters;
